import * as React from 'react';
import styled from '@emotion/styled';
import { red } from '~/theseus/styles/core';

interface Props {
  isError: boolean;
}

const Component = styled.span<Props>`
  display: ${props => (props.isError ? 'block' : 'none')};
  color: ${red};
  font-size: 10pt;
`;

const Error: React.FC<Props & React.HTMLAttributes<HTMLSpanElement>> = props => <Component role="alert" {...props} />;

export default Error;
